export default function () {
  return {
    cartorio: {},
  };
}
